import React from 'react';
import { View, StyleSheet, FlatList } from 'react-native';
import { Typography, Icons } from '@hmsexp/component-library';

const Activities = ({ activities = [] }) => {
  const formatArrDate = arr => {
    const [y, m, d, hh, min, s] = arr;
    const date = new Date(y, m - 1, d, hh, min, s);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    let hours = date.getHours();
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');
    return `${day}/${month}/${year}, ${hours}:${minutes}:${seconds} ${ampm}`;
  };

  if (!activities.length) {
    return (
      <View style={styles.emptyContainer}>
        <Typography variant='body2' fontWeightType='regular'>
          No activities yet.
        </Typography>
      </View>
    );
  }

  const renderItem = ({ item, index }) => (
    <View style={styles.activityItem}>
      <View style={styles.iconContainer}>
        <View style={styles.iconWrapper}>
          <Icons.BellIcon color='primaryContentHigh' size='XL' />
        </View>
        {index < activities.length - 1 && <View style={styles.timelineLine} />}
      </View>

      <View style={styles.activityContent}>
        <Typography variant='subtitle2' fontWeightType='bold' color='primaryContentMedium'>
          {item?.title}
        </Typography>
        <Typography variant='caption' color='textSecondary'>
          {formatArrDate(item?.createdAt)} · {item?.createdBy}
        </Typography>
        {item?.note ? (
          <Typography variant='subtitle2' fontWeightType='regular' color='primaryContentMedium'>
            {item?.note}
          </Typography>
        ) : null}
      </View>
    </View>
  );

  return (
    <FlatList
      data={activities}
      keyExtractor={(item, index) => index.toString()}
      renderItem={renderItem}
      contentContainerStyle={styles.container}
    />
  );
};

const styles = StyleSheet.create({
  container: {
    paddingVertical: 16,
    paddingHorizontal: 20
  },
  emptyContainer: {
    paddingVertical: 16,
    alignItems: 'flex-start'
  },
  activityItem: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 50
  },
  iconContainer: {
    alignItems: 'center',
    marginRight: 16,
    width: 30
  },
  iconWrapper: {
    width: 30,
    height: 30,
    borderRadius: 15,
    backgroundColor: '#e8f1ff',
    alignItems: 'center',
    justifyContent: 'center'
  },
  timelineLine: {
    width: 2,
    flex: 1,
    backgroundColor: '#d0d7de',
    marginTop: 4
  },
  activityContent: {
    flex: 1
  }
});

export default Activities;
